import { render, staticRenderFns } from "./ImportSubstanceUpdatedList.vue?vue&type=template&id=5327275d&scoped=true&"
import script from "./ImportSubstanceUpdatedList.vue?vue&type=script&lang=js&"
export * from "./ImportSubstanceUpdatedList.vue?vue&type=script&lang=js&"
import style0 from "./ImportSubstanceUpdatedList.vue?vue&type=style&index=0&id=5327275d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5327275d",
  null
  
)

export default component.exports